import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../catalog/config/component.config';

export interface ISignUpPopupComponentData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
    position: string;
    init_logic: EInitLogic;
    init_clicks: number;
    init_delay: number;
    init_customer_groups?: string;
    show_email_fields: boolean;
    is_big_popup: boolean;
    popup_heading?: string;
    icon?: string;
    big_popup_heading_style: string;
    big_popup_login_heading: string;
    big_popup_register_heading: string;
    big_popup_main_heading?: string;
    big_popup_login_subtitle: string;
    big_popup_register_subtitle: string;
    big_popup_image?: string;
    bigPopupImageRatio: string;
    bigPopupCloseColor: string;
}

export enum EInitLogic {
    immediate = 'immediate',
    delayed = 'delayed',
    clicks = 'clicks'
}
